export default __webpack_public_path__ + "static/trustpilot-3b58ca8263b31e0efe1dcbe0fad741e4.png";